import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";

export function UploadLoadingState() {
  const { t } = useTranslation(["auth"]);

  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-[var(--background)] px-4">
      <div className="flex flex-col items-center gap-4">
        <Spinner aria-label={t("auth:login.checkingSession")} className="size-10 text-[var(--primary)]" />
        <p className="text-sm text-[var(--muted-foreground)]">{t("auth:login.checkingSession")}</p>
      </div>
    </div>
  );
}

export function UploadGuestState() {
  const { t } = useTranslation(["upload"]);

  return (
    <div className="min-h-[100dvh] bg-[var(--background)] py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto text-center space-y-8">
        <header>
          <h1 className="text-3xl font-bold text-[var(--foreground)]">
            {t("upload:hero.title")}
          </h1>
          <p className="text-[var(--muted-foreground)] mt-2">
            {t("upload:hero.subtitle")}
          </p>
        </header>

        <div className="rounded-[var(--r-lg)] border border-[var(--border)] bg-[var(--card)] p-8 shadow-[var(--sh-xs)]">
          <h2 className="text-xl font-semibold text-[var(--foreground)] mb-3">
            {t("upload:signInPrompt.title")}
          </h2>
          <p className="text-sm text-[var(--muted-foreground)] mb-6">
            {t("upload:signInPrompt.message")}
          </p>
          <Button variant="cta" size="lg" className="mt-6 w-full sm:w-auto" render={<Link to="/login" />}>
            {t("upload:signInPrompt.button")}
          </Button>
        </div>
      </div>
    </div>
  );
}
